import store from '../store';

export default class MessageUtil {
  static handleApiError(error, defaultMsg = '操作失败') {
    let apiMsg = '';
    
    // 1. Check if it's our custom business error (rejected from interceptor)
    if (error && error.msg) {
        apiMsg = error.msg;
    } 
    // 2. Check if it's a standard Axios error with response data
    else if (error.response && error.response.data && error.response.data.msg) {
        apiMsg = error.response.data.msg;
    }
    // 3. Check if it's a standard Error object
    else if (error.message) {
        apiMsg = error.message;
    }

    const message = apiMsg || defaultMsg;
    
    store.commit('snackbar/show', {
      text: message,
      color: 'error'
    });
    
    console.error('API Error:', error);
  }

  static success(message) {
    store.commit('snackbar/show', {
      text: message,
      color: 'success'
    });
  }
  
  static error(message) {
    store.commit('snackbar/show', {
      text: message,
      color: 'error'
    });
  }

  static info(message) {
    store.commit('snackbar/show', {
      text: message,
      color: 'info'
    });
  }

  static warning(message) {
    store.commit('snackbar/show', {
      text: message,
      color: 'warning'
    });
  }
}
